export const getReferenceCheckFields = (t) => [
  { label: t("Company name"), value: "TCS", name: "previousCompanyName" },
  {
    label: t("Person's name to contact for reference"),
    value: "John Michale",
    name: "contactReferenceName",
  },
  { label: t("Contact"), value: "9876543210", name: "referencePhoneNo" },
  { label: t("Role of the person"), value: "Manager", name: "referenceRole" },
];
